angular.module('zc.core')
  .factory('pieChartV2Config', pieChartV2Config);

pieChartV2Config.$inject = ['baseChartV2Config'];
function pieChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'pie' },
      tooltip: { pointFormat: '<b>{point.percentage:.1f}%</b>' },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -60,
            style: {
              fontWeight: 'bold',
              color: 'white',
              textShadow: '0px 1px 2px black'
            }
          }
        }
      }
    }
  }, baseChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/pie_chart_v2_config.service.js